

function parentnode(collections) {
    let node = []
    let nodeobjs = []
    // let thecollections=JSON.parse(JSON.stringify(collections))
    collections.forEach(obj => {
        obj.tree.forEach((el, i) => {
            if (!node.includes(el)) {
                node.push(el)
                nodeobjs.push({ id: el, label: el, children: [], parent: (i > 0 ? obj.tree[i - 1] : "root"),level:i })//(i>0?obj.tree[i-1]:"root")//tree:obj.tree.slice(0,i)
            }
        })
    })
// console.log(node)
//  console.log(nodeobjs)

    return nodeobjs

}


function toattachparent(parentnode, obj) {
    let parentname = obj.tree[obj.tree.length > 0 ? obj.tree.length - 1 : "root"]
    let parent = parentnode.find(obj => { return obj.label === parentname })
    parent.children.push(obj)
}

function loopandattachparent(parentnode, collections) {
    // let thecollections=JSON.parse(JSON.stringify(collections))
    collections.forEach(obj => {
        toattachparent(parentnode, obj)
    })
}

// let theparentnode=parentnode(simpleclct)

// loopandattachparent(theparentnode,simpleclct)

// console.log(theparentnode)

function parentcombine(attachedparent) {
    // attachedparent.sort((a,b)=>{return b.level-a.level})
    // console.log(attachedparent)
    attachedparent.forEach((obj, i) => {
        if (obj.parent != "root") {
            let theparent = attachedparent.find(theobj => {
                return theobj.label === obj.parent
            })
            theparent.children.push(obj)
           // delete attachedparent[i]
        }
    })
    let result=attachedparent.filter((obj,i)=>{
        return obj.level===0
        // if(obj.level!=0){
        //     delete attachedparent[i]
        // }
    })

    return result

}


// parentcombine(theparentnode)

// console.log(theparentnode)

function treeprocess(collections) {
    let theparentnode = parentnode(collections)
    loopandattachparent(theparentnode, collections)
    let result=parentcombine(theparentnode)
    // theparentnode = theparentnode.filter(function (el) {
    //     return el != null;
    // });
    return result
}


// console.log(treeprocess(simpleclct))

export default treeprocess


// WEBPACK FOOTER //
// ./src/components/utility/treeprocess.js